import { STORE_SERVICE_LABELS } from "../../common/App/app-constant";

export function TabPanel(props: any) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && <div>{children}</div>}
        </div>
    );
}

export function a11yProps(index: number) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
    };
}

export interface ServiceTypeDetail {
    type: string;
    status: boolean;
    displayName: string;
    rank: number;
}

export const POS_LIST_TABLE_COLUMNS = [
    STORE_SERVICE_LABELS.POS_NUMBER,
    STORE_SERVICE_LABELS.POS_NAME,
    STORE_SERVICE_LABELS.POS_TYPE,
    STORE_SERVICE_LABELS.SERVICE_TYPE,
    STORE_SERVICE_LABELS.ACTIONS
];